import { render } from "./RemapInfo.vue?vue&type=template&id=55935674&scoped=true"
import script from "./RemapInfo.vue?vue&type=script&lang=js"
export * from "./RemapInfo.vue?vue&type=script&lang=js"

import "./RemapInfo.vue?vue&type=style&index=0&id=55935674&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55935674"]])

export default __exports__